import LanguageService from "../../../service/LanguageService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined,
  name: undefined,
  name_lang: {
    vi: undefined,
    en: undefined,
  },
  icon: undefined,
  ui: {
    allow_paging: false,
  },
  sql: {
    select: undefined,
    update: undefined,
  },
  columns: [],
  id_column: {
    code: undefined,
    type: "string",
  },
  value_columns: [],
};

// Cấu hình bảng danh sách
model.tableRules = {
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "-name",
  defaultSort: ["-name", "descending"],
  fields: "id,name,name_lang,icon",
  filters: "",
  dataSearch: {
    value: {
      name: "",
      "name_lang.vi": "",
      "name_lang.en": "",
    },
    operator: {
      name: ":regex_i:",
      "name_lang.vi": ":regex_i:",
      "name_lang.en": ":regex_i:",
    },
  },
};

// Template cho 1 column
model.columnTemplate = {
  code: "",
  label: "",
  label_lang: {
    vi: "",
    en: "",
  },
  text_align: "left",
  width: null,
  allow_search: false,
  allow_sort: false,
  tooltip: "",
};

// Template cho 1 value_column
model.valueColumnTemplate = {
  code: "",
  default_value_code: "",
  type_mode: "static",
  type: "string",
  type_code: "",
  name: "",
  name_lang: {
    vi: "",
    en: "",
  },
  min_code: "",
  max_code: "",
};

// Options cho type
model.typeOptions = [
  { value: "string", label: "String" },
  { value: "integer", label: "Integer" },
  { value: "long", label: "Long" },
  { value: "double", label: "Double" },
];

// Options cho text_align
model.textAlignOptions = [
  {
    value: "left",
    get label() {
      return LanguageService?.lang?.align_left ?? "align_left";
    },
  },
  {
    value: "center",
    get label() {
      return LanguageService?.lang?.align_center ?? "align_center";
    },
  },
  {
    value: "right",
    get label() {
      return LanguageService?.lang?.align_right ?? "align_right";
    },
  },
];

export default model;
